import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { THEME } from "@/components/@types";
import { onMounted, ref, reactive, watch } from 'vue';
import { BaseInput, BaseButton, BaseIcon } from "@/components/@base";
import { useClientStore } from "@/store/client";
import { storeToRefs } from "pinia";
import { INPUT_MODE } from "@/components/@base/@types";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ScriptEmailStep',
    props: {
        modelValue: { default: null },
        required: { type: Boolean, default: false },
        theme: { default: THEME.light }
    },
    emits: ["update:modelValue", "confirmEntry"],
    setup(__props, { emit: __emit }) {
        const { client } = storeToRefs(useClientStore());
        const props = __props;
        const emits = __emit;
        const emails = ref([null]);
        const temp = ref([]);
        const data = reactive({ ...emails.value });
        const dataChanges = ref(false);
        const disableBtn = ref(true);
        function setValue(evt, idx) {
            data[idx] = evt;
        }
        function addEmail() {
            for (let prop in data) {
                emails.value[prop] = data[prop];
            }
            emails.value.push(null);
        }
        function deleteEmail(idx) {
            delete data[idx];
            emails.value.splice(idx, 1);
            let i = 0;
            for (let prop in data) {
                emails.value[i] = data[prop];
                i++;
            }
        }
        function handleEnter() {
            emits('confirmEntry');
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        function checkValid(val) {
            return val?.length ? emailRegex.test(val) : true;
        }
        watch(() => data, () => {
            let i = 0;
            temp.value = [];
            for (let prop in data) {
                if (emailRegex.test(data[prop])) {
                    temp.value[i] = data[prop];
                }
                i++;
            }
            if (temp.value.length === Object.keys(data).length) {
                disableBtn.value = false;
            }
            else {
                disableBtn.value = true;
            }
            emits('update:modelValue', temp.value.filter((el) => el));
            if (client.value?.mail?.value)
                client.value.mail.value = [...temp.value.filter((el) => el)];
            dataChanges.value = true;
        }, { deep: true });
        watch(() => emails.value, (newVal) => {
            for (let prop in data) {
                delete data[prop];
            }
            newVal.forEach((el, idx) => {
                data[idx] = el;
            });
        }, { deep: true });
        watch(() => client.value?.mail?.value, (newVal) => {
            if (!dataChanges.value) {
                emails.value = Array.isArray(newVal) ? [...newVal] : [newVal];
            }
            dataChanges.value = false;
        }, { deep: true });
        onMounted(() => {
            if (props.modelValue) {
                emails.value = [];
                if (typeof props.modelValue === 'string') {
                    props.modelValue.replace(' ', '').split(',').forEach((el) => {
                        emails.value.push(el);
                    });
                }
                else {
                    props.modelValue.forEach((el) => {
                        emails.value.push(el);
                    });
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emails.value, (email, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: email + '' + idx,
                        class: "email-container"
                    }, [
                        _createVNode(_unref(BaseInput), {
                            "model-value": data[idx],
                            theme: props.theme,
                            required: props.required,
                            mode: _unref(INPUT_MODE).email,
                            width: "250px",
                            class: _normalizeClass(!checkValid(data[idx]) ? 'invalid' : ''),
                            "onUpdate:modelValue": ($event) => (setValue($event, idx)),
                            onConfirmEntry: handleEnter
                        }, null, 8, ["model-value", "theme", "required", "mode", "class", "onUpdate:modelValue"]),
                        (emails.value.length > 1)
                            ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                                key: 0,
                                name: "delete",
                                size: "24",
                                onClick: ($event) => (deleteEmail(idx))
                            }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                    ]));
                }), 128)),
                _createVNode(_unref(BaseButton), {
                    label: "Добавить",
                    disabled: disableBtn.value,
                    theme: props.theme,
                    onClick: addEmail
                }, null, 8, ["disabled", "theme"])
            ]));
        };
    }
});
